/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportType } from './ImportType';
import {
    ImportTypeFromJSON,
    ImportTypeFromJSONTyped,
    ImportTypeToJSON,
    ImportTypeToJSONTyped,
} from './ImportType';
import type { FieldMappingDto } from './FieldMappingDto';
import {
    FieldMappingDtoFromJSON,
    FieldMappingDtoFromJSONTyped,
    FieldMappingDtoToJSON,
    FieldMappingDtoToJSONTyped,
} from './FieldMappingDto';

/**
 * 
 * @export
 * @interface SaveAsProfileRequest
 */
export interface SaveAsProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveAsProfileRequest
     */
    name: string | null;
    /**
     * 
     * @type {ImportType}
     * @memberof SaveAsProfileRequest
     */
    importType?: ImportType;
    /**
     * 
     * @type {Array<FieldMappingDto>}
     * @memberof SaveAsProfileRequest
     */
    mappings?: Array<FieldMappingDto> | null;
}



/**
 * Check if a given object implements the SaveAsProfileRequest interface.
 */
export function instanceOfSaveAsProfileRequest(value: object): value is SaveAsProfileRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SaveAsProfileRequestFromJSON(json: any): SaveAsProfileRequest {
    return SaveAsProfileRequestFromJSONTyped(json, false);
}

export function SaveAsProfileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveAsProfileRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'importType': json['importType'] == null ? undefined : ImportTypeFromJSON(json['importType']),
        'mappings': json['mappings'] == null ? undefined : ((json['mappings'] as Array<any>).map(FieldMappingDtoFromJSON)),
    };
}

export function SaveAsProfileRequestToJSON(json: any): SaveAsProfileRequest {
    return SaveAsProfileRequestToJSONTyped(json, false);
}

export function SaveAsProfileRequestToJSONTyped(value?: SaveAsProfileRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'importType': ImportTypeToJSON(value['importType']),
        'mappings': value['mappings'] == null ? undefined : ((value['mappings'] as Array<any>).map(FieldMappingDtoToJSON)),
    };
}

